import React from 'react';
import styles from './upload-csv-instructions.module.scss';
import { Heading, Table } from '@flixbus/honeycomb-react';

const UploadCSVInstructions: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <Heading size={3} flushSpace>
          Instructions
        </Heading>
        <p className={styles.paragraph}>
          How to disable existing vouchers by uploading a CSV file.
        </p>
      </div>
      <div>
        <div className={styles.instructions}>
          <div className={styles.instruction}>
            <span className={styles.number}>1</span>
            <span>
              Create a CSV file that has only the <span className={styles.bold}>CODE</span> column.
            </span>
          </div>
          <div className={styles.instruction}>
            <span className={styles.number}>2</span>
            <span>
              Add the <span className={styles.bold}>voucher codes</span> that you wish to disable.
            </span>
          </div>
        </div>
        <Table
          extraClasses={styles.table}
          rows={[['FLIX123'], ['FLIX234'], ['FLIX345']]}
          headers={['Code']}
        />
      </div>
    </div>
  );
};

export default UploadCSVInstructions;
